import { db } from "./firebase";
import {
  collection, addDoc, getDocs, getDoc, updateDoc, setDoc,
  doc, query, where, orderBy, serverTimestamp
} from "firebase/firestore";

const BAL_COL = "balances";
const TXN_COL = "transactions";

// Get customer balance
export async function getBalance(email) {
  const snap = await getDoc(doc(db, BAL_COL, email.toLowerCase().trim()));
  return snap.exists() ? snap.data().amount : 0;
}

// Get all balances (admin)
export async function getAllBalances() {
  const snap = await getDocs(collection(db, BAL_COL));
  return snap.docs.map(d => ({ email: d.id, ...d.data() }));
}

// Add/subtract from balance (admin)
export async function adjustBalance(email, amount, note, type = "adjustment") {
  const ref     = doc(db, BAL_COL, email.toLowerCase().trim());
  const snap    = await getDoc(ref);
  const current = snap.exists() ? snap.data().amount : 0;
  const newAmt  = current + amount;

  await setDoc(ref, { email: email.toLowerCase().trim(), amount: newAmt, updatedAt: serverTimestamp() }, { merge: true });

  // Log transaction
  await addDoc(collection(db, TXN_COL), {
    email:     email.toLowerCase().trim(),
    amount,
    type,      // "topup" | "adjustment" | "charge"
    note:      note || "",
    balance:   newAmt,
    createdAt: serverTimestamp(),
  });

  return newAmt;
}

// Get transaction history for customer
export async function getTransactions(email) {
  const q = query(
    collection(db, TXN_COL),
    where("email", "==", email.toLowerCase().trim()),
    orderBy("createdAt", "desc")
  );
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

// Get all transactions (admin)
export async function getAllTransactions() {
  const q    = query(collection(db, TXN_COL), orderBy("createdAt", "desc"));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}
